import { render, staticRenderFns } from "./SensorAddUpdate.html?vue&type=template&id=fa912744&scoped=true&"
import script from "./SensorAddUpdate.vue?vue&type=script&lang=js&"
export * from "./SensorAddUpdate.vue?vue&type=script&lang=js&"
import style0 from "./SensorAddUpdate.vue?vue&type=style&index=0&id=fa912744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa912744",
  null
  
)

export default component.exports